import { useRef as t, useState as e, useLayoutEffect as n } from "react";
var o = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  r = /^\s+|\s+$/g,
  i = /^[-+]0x[0-9a-f]+$/i,
  u = /^0b[01]+$/i,
  l = /^0o[0-7]+$/i,
  f = parseInt,
  c = "object" == typeof o && o && o.Object === Object && o,
  a = "object" == typeof self && self && self.Object === Object && self,
  s = c || a || Function("return this")(),
  d = Object.prototype.toString,
  v = Math.max,
  p = Math.min,
  m = function () {
    return s.Date.now();
  };
function b(t) {
  var e = typeof t;
  return !!t && ("object" == e || "function" == e);
}
function y(t) {
  if ("number" == typeof t) return t;
  if (function (t) {
    return "symbol" == typeof t || function (t) {
      return !!t && "object" == typeof t;
    }(t) && "[object Symbol]" == d.call(t);
  }(t)) return NaN;
  if (b(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = b(e) ? e + "" : e;
  }
  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(r, "");
  var n = u.test(t);
  return n || l.test(t) ? f(t.slice(2), n ? 2 : 8) : i.test(t) ? NaN : +t;
}
var g = function (t, e, n) {
  var o,
    r,
    i,
    u,
    l,
    f,
    c = 0,
    a = !1,
    s = !1,
    d = !0;
  if ("function" != typeof t) throw new TypeError("Expected a function");
  function g(e) {
    var n = o,
      i = r;
    return o = r = void 0, c = e, u = t.apply(i, n);
  }
  function h(t) {
    return c = t, l = setTimeout(w, e), a ? g(t) : u;
  }
  function j(t) {
    var n = t - f;
    return void 0 === f || n >= e || n < 0 || s && t - c >= i;
  }
  function w() {
    var t = m();
    if (j(t)) return T(t);
    l = setTimeout(w, function (t) {
      var n = e - (t - f);
      return s ? p(n, i - (t - c)) : n;
    }(t));
  }
  function T(t) {
    return l = void 0, d && o ? g(t) : (o = r = void 0, u);
  }
  function N() {
    var t = m(),
      n = j(t);
    if (o = arguments, r = this, f = t, n) {
      if (void 0 === l) return h(f);
      if (s) return l = setTimeout(w, e), g(f);
    }
    return void 0 === l && (l = setTimeout(w, e)), u;
  }
  return e = y(e) || 0, b(n) && (a = !!n.leading, i = (s = "maxWait" in n) ? v(y(n.maxWait) || 0, e) : i, d = "trailing" in n ? !!n.trailing : d), N.cancel = function () {
    void 0 !== l && clearTimeout(l), c = 0, o = f = r = l = void 0;
  }, N.flush = function () {
    return void 0 === l ? u : T(m());
  }, N;
};
const h = o => {
  const {
      onProgress: r,
      windowScroll: i,
      timeout: u
    } = o || {},
    l = t(null),
    [f, c] = e({
      vertical: 0,
      horizontal: 0
    });
  return n(() => {
    let t = !0;
    const e = i ? document.scrollingElement : l.current,
      n = i ? document : l.current,
      o = g(() => {
        if (t && e) {
          const {
              scrollTop: t,
              scrollHeight: n,
              clientHeight: o,
              scrollLeft: i,
              scrollWidth: u,
              clientWidth: l
            } = e,
            f = (t, e, n) => +(t / (e - n) * 100).toFixed(2),
            a = f(t, n, o),
            s = f(i, u, l),
            d = {
              vertical: isNaN(a) ? 0 : a,
              horizontal: isNaN(s) ? 0 : s
            };
          c(d), null == r || r(d);
        }
      }, null != u ? u : 10);
    return null == n || n.addEventListener("scroll", o), () => {
      t = !1, null == n || n.removeEventListener("scroll", o);
    };
  }, [r, l, u, i]), {
    percentage: f,
    ref: l
  };
};
export { h as default, h as useInfiniteScroll };